/** @module Specification/SharedSpecSectionsSwitchboardOnLibMaterials */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/toolbar/MultiSelectSwitchboard",
	"src/SpecificationDataSheet/sharedSectionMatrixService",
], function(declare, _, MultiSelectSwitchboard, {getMatrixPresence}) {
	return declare(MultiSelectSwitchboard, {
		idViewProperty: "selectedSharedSpecSections",
		disableButtonAction: true,
		refreshStoreOptions: true,
		switchboardPath: "Child:AllSharedSpecSectionsOnLibMaterial",
		hideGo: true,

		/**
		 * @override
		 * Add NONE and ALL option to select widget
		 */
		onSelectParams: function(/*Object*/ params) {
			params.defaultClearText = "SelectNone";
			params.addItemAll = true;
		},

		/**
		 * @override
		 * Show the switchboard if there is at least one SharedSpecSections and the matrix is chosen
		 */
		canShowPlugin: function() {
			const view = this.getView();
			const matrixAvailability = getMatrixPresence(view.attributeSpecs);

			// if shared section is not part of the view, no need to show switchboard
			if (!matrixAvailability.specSectionIsAvailable) {
				return false;
			}

			const node = view.getViewNode();
			const sectionUrls = node && node.AllSharedSpecSectionsOnLibMaterial;
			return !_.isEmpty(sectionUrls);
		},
	});
});